import { Box, Card, CardContent, Skeleton, Stack } from "@mui/material";
import { AppointmentCTA } from "../../components/Home/AppointmentCTA";
import { useEffect, useState } from "react";
import { getMyNextAppointment, MyNextAppointment } from "../../services/my-appointments.service";
import { getPendingPix, PixPendingPayment } from "../../services/payment.service";
import { UpcomingAppointmentCard } from "../../components/Appointments/UpcomingAppointmentCard";

export function Homepage() {
  const [appt, setAppt] = useState<MyNextAppointment | null>(null);
  const [pendingPix, setPendingPix] = useState<PixPendingPayment | null>(null);
  const [loading, setLoading] = useState(true);

  const reloadNext = async () => {
    try {
      const a = await getMyNextAppointment();
      setAppt(a);
      if (a?.status === 'PAGAMENTO_PENDENTE') {
        const pix = await getPendingPix();
        setPendingPix(pix);
      } else {
        setPendingPix(null);
      }
    } catch {
      // ignore
    }
  };

  useEffect(() => {
    let ignore = false;
    async function load() {
      try {
        const a = await getMyNextAppointment();
        if (!ignore) setAppt(a);

        if (!ignore) {
          if (a?.status === 'PAGAMENTO_PENDENTE') {
            try {
              const pix = await getPendingPix();
              setPendingPix(pix);
            } catch {
              setPendingPix(null);
            }
          } else {
            setPendingPix(null);
          }
        }
      } catch {}
      finally {
        if (!ignore) setLoading(false);
      }
    }
    load();
    return () => { ignore = true };
  }, []);

  return (
    <Box
      width="100%"
      padding={4}
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 4,
        alignItems: "center",
        minHeight: "calc(100vh - 64px)",
      }}
    >
      {loading && (
        <Card sx={{ width: "100%", maxWidth: 800, mx: "auto" }}>
          <CardContent>
            <Stack spacing={1}>
              <Skeleton variant="text" width={180} height={32} />

              <Stack direction="row" spacing={1}>
                <Skeleton variant="text" width={80} />
                <Skeleton variant="rounded" width={120} height={28} />
              </Stack>

              <Stack spacing={0.5}>
                <Skeleton variant="text" width={60} />
                <Skeleton variant="text" width={260} />
              </Stack>

              <Skeleton variant="rectangular" height={1} sx={{ my: 1 }} />

              <Stack direction="row" spacing={4}>
                <Stack>
                  <Skeleton variant="text" width={40} />
                  <Skeleton variant="text" width={80} />
                </Stack>
                <Stack>
                  <Skeleton variant="text" width={40} />
                  <Skeleton variant="text" width={80} />
                </Stack>
                <Stack>
                  <Skeleton variant="text" width={50} />
                  <Skeleton variant="rounded" width={90} height={24} />
                </Stack>
              </Stack>
            </Stack>
          </CardContent>
        </Card>
      )}

      {!loading && appt && (
        <UpcomingAppointmentCard appt={appt} pendingPix={pendingPix} />
      )}

      {!loading && !appt && (
        <AppointmentCTA onAppointmentConfirmed={reloadNext} />
      )}
    </Box>
  );
}
